const state = {
  forms: {},
};

const actions = {
  ClearFormClipboard({ commit }) {
    commit('CLEAR_FORM_CLIPBOARD');
  },

  CopyForm({ commit }, { formId, values }) {
    commit('COPY_FORM', { formId, values });
  },
};

const mutations = {
  COPY_FORM(stateArg, { formId, values }) {
    const stateCopy = stateArg;
    stateCopy.forms[formId] = values;
  },

  CLEAR_FORM_CLIPBOARD(stateArg) {
    const stateCopy = stateArg;
    stateCopy.forms = {};
  },
};

export default { actions, mutations, state };
